import styled from 'styled-components';

export const ChatNow = styled.button`
  padding: 0;
  text-decoration: underline;
  outline: none;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
`;

export const AvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
